import React from 'react';
import moment from 'moment';

const Footer = () => (
  <div className="legal">
    &copy;
    {moment().format('YYYY')}
    &nbsp;iSikhnas
  </div>
);
export default Footer;
